import React from 'react';
import { useNavigate } from 'react-router-dom';

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="welcome-page">
      <div className="welcome-hero">
        <div className="welcome-content">
          <h1 className="welcome-title">Undistracted, Unincentivized Writing</h1>
          <p className="welcome-subtitle">
            The deincentivized platform for writing, reading, learning, and collaborating.
          </p>
          <div className="welcome-actions">
            <button
              className="btn btn-primary btn-large"
              onClick={() => navigate('/editor')}
            >
              Start Writing
            </button>
            <button
              className="btn btn-secondary btn-large"
              onClick={() => navigate('/explore')}
            >
              Explore Stories
            </button>
          </div>
        </div>
      </div>

      <div className="welcome-explanation">
        <div className="explanation-content">
          <h2>A more focuesed approach.</h2>
          <p>
            Removing, likes, comments, and shares from the writing experience allows both writers and readers to focus on what matters most: the content itself.
          </p>
          <p>
            Content collaboration and discussion remains in the form of long-form writing. Revisions, responses, and more
            demand thoughtful engagement over quick reactions, as is seen in the scientific and academic communities.
          </p>
          <p>
            Whether you're sharing personal reflections, exploring complex ideas, or contributing to
            important conversations, Flow gives you the space to write with intention and connect
            with readers who value depth over virality.
          </p>
          <button
            className="btn btn-primary btn-large charter-button"
            onClick={() => {
              navigate('/blog/for-the-love-of-writing');
              window.scrollTo(0, 0);
            }}
          >
            View Charter
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomePage;